import { ApiResponse } from "api/HttpClient";
import { RefabricProURL } from "api/index";
import {
  IBrowzwearConnectRequest,
  IBrowzwearConnectResponse,
  IBrowzwearExportRequest,
  IBrowzwearExportResponse,
  IBrowzwearImportRequest,
  IBrowzwearImportResponse,
  IBrowzwearStatusResponse,
} from "./browzwear.type";

export default {
  async connect(data: IBrowzwearConnectRequest): Promise<ApiResponse<IBrowzwearConnectResponse>> {
    return await RefabricProURL.post("browzwear/connect", data, {});
  },

  /**
   * Is this user connected? Asked on mount instead of asking the user, which is what makes a page
   * reload stop demanding an API secret (REF-6498). Reading it also slides the session's TTL.
   */
  async status(): Promise<ApiResponse<IBrowzwearStatusResponse>> {
    return await RefabricProURL.get("browzwear/status", {});
  },

  async disconnect(): Promise<ApiResponse<IBrowzwearStatusResponse>> {
    return await RefabricProURL.post("browzwear/disconnect", {}, {});
  },

  async import(data: IBrowzwearImportRequest = {}): Promise<ApiResponse<IBrowzwearImportResponse>> {
    return await RefabricProURL.post("browzwear/import", data, {});
  },

  /**
   * Re-walk Stylezone and refresh the mirror — the Refresh button. `import` serves the mirror and
   * never re-walks on its own, so this is the only slow call and the user asked for it (REF-6498).
   */
  async sync(): Promise<ApiResponse<IBrowzwearImportResponse>> {
    return await RefabricProURL.post("browzwear/sync", {}, {});
  },

  async export(data: IBrowzwearExportRequest): Promise<ApiResponse<IBrowzwearExportResponse>> {
    return await RefabricProURL.post("browzwear/export", data, {});
  },
};
